import AppService from "@service/AppService/AppService";
import { MILK_DONATION_LOCATION_TO_STATE, MILK_DONATION_OTHER_LABEL } from "./MilkDonationLocationStateMap";
import { surveyQuestionMethods } from "@shared/Questions/Questions";

export const MILK_DONATION_LOCATION_FIELD = "Location_of_Milk_Donation__c";
export const MILK_DONATION_STATE_FIELD = "State__c";

function stateAnswerHasValue(stateAnswer) {
    const v = stateAnswer?.userAnswer;
    return v != null && String(v).trim() !== "";
}

export function isMilkDonationStateTextQuestion(question) {
    return AppService.accountType === "milk_donor" && question?.salesForceField?.fieldName === MILK_DONATION_STATE_FIELD;
}

export function applyMilkDonationStateFromLocation(selectedTopic, selectedLocationAnswerText) {
    if (AppService.accountType !== "milk_donor") {
        return { shouldSaveState: false, stateQuestion: null, stateAnswer: null };
    }

    const stateQuestion = selectedTopic.questions?.find((q) => q.salesForceField?.fieldName === MILK_DONATION_STATE_FIELD);
    if (!stateQuestion?.answers?.length) {
        return { shouldSaveState: false, stateQuestion: null, stateAnswer: null };
    }

    const stateAnswer = stateQuestion.answers[0];
    const text = selectedLocationAnswerText == null ? "" : String(selectedLocationAnswerText).trim();

    if (text === "") {
        return { shouldSaveState: false, stateQuestion: null, stateAnswer: null };
    }

    if (text === MILK_DONATION_OTHER_LABEL) {
        if (!stateAnswerHasValue(stateAnswer)) {
            return { shouldSaveState: false, stateQuestion: null, stateAnswer: null };
        }
        stateAnswer.userAnswer = "";
        surveyQuestionMethods.setLastAnswerId(stateQuestion, stateAnswer);
        return { shouldSaveState: true, stateQuestion, stateAnswer };
    }

    const mapped = MILK_DONATION_LOCATION_TO_STATE[text];
    if (mapped) {
        stateAnswer.userAnswer = mapped;
        surveyQuestionMethods.setLastAnswerId(stateQuestion, stateAnswer);
        return { shouldSaveState: true, stateQuestion, stateAnswer };
    }

    return { shouldSaveState: false, stateQuestion: null, stateAnswer: null };
}

export function getMilkDonationSelectedLocationText(selectedTopic) {
    const locationQuestion = selectedTopic.questions?.find((q) => q.salesForceField?.fieldName === MILK_DONATION_LOCATION_FIELD);
    if (!locationQuestion || locationQuestion.type !== "DROPDOWN") {
        return null;
    }
    const listName = surveyQuestionMethods.lastAnswerListName();
    const ids = locationQuestion[listName];
    if (!ids?.length) {
        return "";
    }
    return ids[0];
}

export function getMilkDonationStateFieldUiMode(locationText) {
    const t = String(locationText ?? "").trim();
    if (t) {
        if (t === MILK_DONATION_OTHER_LABEL) {
            return "otherSelect";
        }
        if (MILK_DONATION_LOCATION_TO_STATE[t]) {
            return "mappedReadonly";
        }
    }
    return "default";
}
